export const GET_INSIDE_SALES_REQUEST = 'GET_INSIDE_SALES_REQUEST';
export const GET_INSIDE_SALES_SUCCESS = 'GET_INSIDE_SALES_SUCCESS';
export const GET_INSIDE_SALES_FAILURE = 'GET_INSIDE_SALES_FAILURE';
